import {
  ProfileDispatcher,
  ProfileHeader,
  ProfileHeaderProps,
} from '@pelando/components';
import { PropsWithChildren } from 'react';
import { isCashbackClaimEnabled } from '@/presentation/services/featureFlags';
import { getContactPelandoUrl } from '@/presentation/services/urls';
import { useRouter } from 'next/router';
import { useTranslation } from '@/presentation/hooks/useTranslation';
import { MY_DATA, MY_PROFILE } from '@/presentation/services/urls/consts';
import { Langs } from '@/locales';
import { ContentWrapper, PageContainer } from '../../styles';
import { ContactButton, ProfileHeaderContainer } from './style';

type WrapperProps = PropsWithChildren<{
  userData: ProfileHeaderProps['user'] & {
    isOwner?: boolean;
    isLogged?: boolean;
    isAdmin?: boolean;
    isVerified?: boolean;
  };
  isFollowing?: boolean;
  command: ProfileDispatcher;
}>;

function Wrapper({ children, command, userData, isFollowing }: WrapperProps) {
  const { t } = useTranslation('profile');
  const { locale, push, pathname } = useRouter();
  const { isOwner, isLogged, isAdmin, isVerified, ...userProps } = userData;
  const showMyData = isCashbackClaimEnabled();
  const isMyProfilePage = pathname.includes(MY_PROFILE[locale as Langs]);
  const hideProfileCard = pathname.includes(MY_DATA[locale as Langs]);

  const handleClickContactButton = () => {
    push(getContactPelandoUrl(locale));
  };

  return (
    <PageContainer>
      <ContentWrapper>
        <ProfileHeaderContainer data-hidden-layout={hideProfileCard}>
          <ProfileHeader
            isOwner={isOwner}
            isLogged={isLogged}
            isAdmin={isAdmin}
            actions={command}
            user={userProps}
            isFollowing={isFollowing}
            isVerified={isVerified}
            hasMyDataButton={showMyData}
          />
          {isMyProfilePage && (
            <ContactButton light onClick={handleClickContactButton}>
              {t('my-profile-contact-button')}
            </ContactButton>
          )}
        </ProfileHeaderContainer>
        <div>{children}</div>
      </ContentWrapper>
    </PageContainer>
  );
}

export default Wrapper;
